/* Shared helpers of the central site scripts. */
export const QC = window.QC || {};
export const FA = n => String(n).replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]).replace(/\./g, '٫');
export const tint = (c, p) => `color-mix(in srgb, ${c} ${p}%, white)`;
export const soft = (c, p) => `color-mix(in srgb, ${c} ${p}%, transparent)`;
export const AC = '#7C3AED';
export const LOGOS = Object.fromEntries((QC.logos || []).map(l => [l.key, l]));
export const logo = (k, cls = 'size-12') => {
  const l = LOGOS[k] || {title: k, logo: ''};
  return `<span class="logo-dot ${cls}" title="${l.title}"><img src="${l.logo}" alt="${l.title}" decoding="async" onerror="this.replaceWith(Object.assign(document.createElement('b'),{className:'text-[9px] font-black text-primary-500',textContent:'${String(l.title).slice(0,4)}'}))"></span>`;
};
export const packages = () => QC.packages || [];
export const pkg = key => packages().find(p => p.key === key) || packages()[0] || {};
